import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-17-delete",
  "use": "icon-icon-17-delete-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-icon-17-delete\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h16v16H0z\" /><path d=\"M14 4a1 1 0 0 1 0 2h-1v8a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V6H2a1 1 0 1 1 0-2h12zm-3 2H5v7h6V6zm-1-5a1 1 0 0 1 0 2H6a1 1 0 1 1 0-2h4z\" fill=\"currentColor\" fill-rule=\"nonzero\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol